class TextDetail extends HTMLElement {
  constructor() {
    super()

    this.thisbtn = this
    this.screenWidth = window.innerWidth
    this.modal = document.querySelector(`.textDetail-${this.id}`)
    this.modalContent = document.querySelector(`.textDetail-${this.id} .modal-content`)
    this.closebtn = document.querySelector(`.textDetail-${this.id} .customModalClose`)
    this.header = document.querySelector("#customHeader")

    this.close.bind(this)

    this.closebtn.addEventListener("click", this.close.bind(this))
    this.thisbtn.addEventListener("click", this.open.bind(this))
    this.modal.addEventListener("click", this.close.bind(this))
  }

  updateCloseButton() {
    if (this.screenWidth <= "499") {
      this.closebtn.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="37.477" height="37.477" viewBox="0 0 37.477 37.477">
            <text data-name="+" transform="rotate(45 10.96 26.46)" style="fill:#fff;font-size:30px;font-family:Calibre-Thin,Calibre;font-weight:200;letter-spacing:.045em">
              <tspan x="-7.425" y="20">+</tspan>
            </text></svg>`
    }
  }

  open() {
    this.modal.style.display = "block"
    document.body.classList.add("modalOpen")
    this.header.classList.add("poupOpen")
  }

  close() {
    this.modal.style.display = "none"
    document.body.classList.remove("modalOpen")
    this.header.classList.remove("poupOpen")
  }

}

customElements.define("text-detail", TextDetail)
